import {Pipe, PipeTransform} from '@angular/core';

declare var twemoji: any;

@Pipe({
  name: 'emoji',
  standalone: true,
})
export class EmojiPipe implements PipeTransform {
  transform(value: string): string {
    if (value == null) {
      return '';
    }
    try {
      return twemoji.parse(value);
    } catch (error) {
      return value;
    }
  }
}
